import React from 'react';
import { Box } from '@mui/material';
import StepperForm from './components/StepperForm';
import ProtectedFullVersion from './components/ProtectedFullVersion';

function App() {
  const currentPath = window.location.pathname;
  
  if (currentPath === '/vollversion') {
    return <ProtectedFullVersion />;
  }

  const isFullWidth = currentPath === "/" || currentPath === "/start";

  return (
<Box sx={{ width: "100%", mt: 4 }}>
  {isFullWidth ? (
    <Box
      sx={{
        width: "100vw",
        ml: "calc(-50vw + 50%)",
        background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
        py: 4,
      }}
    >
      <Box sx={{ px: { xs: 2, sm: 4, md: 6 } }}>
        <StepperForm />
      </Box>
    </Box>
  ) : (
    <Container maxWidth="md">
      <StepperForm />
    </Container>
  )}
</Box>

  );
}

export default App;

